import { HttpErrorResponse } from "@angular/common/http";

export class ErrorHandlerService{
    
    getClientMessage(error: Error): string{
        if(!navigator.onLine){
            return 'No connection';
        }
        return error.message ? error.message : error.toString();
    }

    getClientStack(error: Error): string{
        return error.stack;
    }

    getServerMessage(error: HttpErrorResponse): string{
        //alert(error.error);
        switch(error.status){
            case 400: if(error.error.error == 'invalid_grant') return 'INVALID-GRANT'; return error.error ? error.error : error.message;
            case 401: return error.error ? error.error : 'UNAUTHORIZED';//'Nemate dovoljna korisnička prava za ovu akciju';
            case 403: return error.error ? error.error : error.message;
            case 409: return error.error ? error.error : error.message;
            case 500: return 'INTERNAL-SERVER-ERROR';//'Greška na serveru';
          case 502: case 0:
            let origin = "";
            if (error.url) {
              origin = new URL(error.url).origin;
            }
            return 'NO-CONNECTION-TO-SERVER';//'Nema konekcije ka serveru';
          default: return error.message;
        }
    }

    getServerStack(error: HttpErrorResponse): string{
        return 'stack';
    }
}
